export default __webpack_public_path__ + "static/media/dispenser-hero-banner.ecf3c2a0.mp4";